import { FormFieldTypes } from "../../../data/formFieldType";

export const SGBPCategoryCriteriaData = {
  name: "AdditionalInfo",
  initialState: {
    searchbyCode: "",
    channel: null,
    statusId: null,
    categoryId: null,
    subCategoryId: null,
    typeId: null,
  },
  formFields: [
    {
      id: "searchbyCode",
      lable: "Search by Code",
      Field_Name: "Search by Code",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchbyCode",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-8 mb-3 pr-0",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "categoryId",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
    {
      id: "subCategoryId",
      lable: "Sub Category",
      Field_Name: "Sub Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subCategoryId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
    {
      id: "typeId",
      lable: "Type",
      Field_Name: "Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeId",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
